import type { SmsProviderTestResult } from '@/api/notificationProviders/notificationProvidersApi.types';

export type SmsTestResultTone = 'success' | 'warning' | 'error';

export interface SmsTestResultPresentation {
  tone: SmsTestResultTone;
  messageKey: string;
  providerErrorCode: number | null;
}

export function presentSmsTestResult(result: SmsProviderTestResult): SmsTestResultPresentation {
  if (result.outcome === 'delivered') {
    return {
      tone: 'success',
      messageKey: 'providers.sms.testOutcome.delivered',
      providerErrorCode: null,
    };
  }
  if (result.outcome === 'pending') {
    return {
      tone: 'warning',
      messageKey: 'providers.sms.testOutcome.pending',
      providerErrorCode: null,
    };
  }
  if (result.outcome === 'not_configured') {
    return {
      tone: 'warning',
      messageKey: 'providers.sms.testOutcome.notConfigured',
      providerErrorCode: null,
    };
  }
  const failureReason = result.failureReason === null ? 'unknown' : result.failureReason;
  return {
    tone: 'error',
    messageKey: 'providers.sms.failureReason.' + failureReason,
    providerErrorCode: result.providerErrorCode,
  };
}
